export class EntityFieldAccessor<T> {
    public getFieldPath(property: (object: T) => void) {
        const match = this.getMatch(property);
        if (!match) {
            throw new Error("Invalid property path");
        }
        return match;
    }
    public getPropertyFilterPath(property: (object: T) => void): string {
        const match = this.getMatch(property);

        if (!match) {
            throw new Error("Invalid property path");
        }
        return match.propertyPath;
    }

    private getMatch(property: (object: T) => void) {
        const tsString = property.toString();
        const dotIdentifiers = tsString.match(/\.[a-zA-Z0-9_]+/g);
        if (dotIdentifiers && dotIdentifiers.length) {
            const propertyPath = dotIdentifiers.map((r) => r.substring(1)).join(".");
            const column = dotIdentifiers[dotIdentifiers.length - 1].substring(1);
            return { propertyPath, column };
        }
        return null;
    }
}
